import { UserType } from '@luminovo/api-contracts';

/**
 * Persona discriminator sent on analytics identify calls (Segment, Intercom).
 *
 * Derived from `UserType` and lowercased to match the value emitted by the
 * backend Segment identify (`rust-workspace/domain-events/src/lib.rs::identify_and_group_user`),
 * so audience filters on `user_type` work consistently across destinations.
 */
export type UserTypeTrait = Lowercase<`${UserType}`>;

/**
 * Maps a `UserType` to its analytics-trait string representation.
 */
export function toUserTypeTrait(userType: UserType): UserTypeTrait {
    return userType.toLowerCase() as UserTypeTrait;
}

export type IdentifyTraits = {
    email: string;
    language: string;
    user_type: UserTypeTrait;
    is_from_customer: boolean;
    customer_name?: string;
    host: string;
    tenant: string;
    has_access_to_customer_portal: boolean;
    has_access_to_source_to_contract: boolean;
    has_full_manufacturing_access: boolean;
    has_customers: boolean;
    client_type: string;
    is_closed_beta_tester: boolean;
};

export type OrganizationTraits = {
    name: string;
    has_access_to_customer_portal: boolean;
    has_access_to_source_to_contract: boolean;
    is_closed_beta_tester: boolean;
    has_full_manufacturing_access: boolean;
    has_customers: boolean;
    client_type: string;
};
